export declare interface Authenticate {
  readonly UserName: string;
  readonly Password: string;
}

// local
// export const apiUrl = 'http://localhost:49785/api/';

// trienpont local
// export const apiUrl = 'https://cp-gateway.ap.ngrok.io/api/';

// Logic to decide whether to use prod or preprod api's
export const apiUrl = `${process.env.VUE_APP_GATEWAY_API_ENDPOINT}`;

const cphqApiBase =
  process.env.VUE_APP_CPHQ_API_ENDPOINT ?? 'https://api.staging.secureplatformtech.com/';

export const cphqApiUrl = cphqApiBase.endsWith('/') ? cphqApiBase : `${cphqApiBase}/`;

const endpoints = {
  authenticate: apiUrl + 'authentication',
  updatePassword: apiUrl + 'authentication/updatepassword',
  resetPassword: apiUrl + 'authentication/passwordreset',
  accounts: apiUrl + 'accounts/',
  standardfees: apiUrl + 'accounts/fees',
  accountStatement: apiUrl + 'accounts/accountstatement',
  accountStatementDownload: apiUrl + 'accounts/accountstatementurl',
  transactionHistory: apiUrl + 'accounts/cashTransactionHistory',
  accountSummary: apiUrl + 'accounts/summary/',
  CMA: apiUrl + 'accounts/CMA/',
  holdings: apiUrl + 'accounts/holdings/',
  nonMoventumHoldings: apiUrl + 'accounts/reported/valuation',
  nonMoventumHoldingsTotal: apiUrl + 'accounts/reported/valuationgrouping',
  sellNonMoventumHoldings: apiUrl + 'accounts/dealinginstruction',
  holdingTransactions: apiUrl + 'accounts/holdingtransactions/',
  projections: apiUrl + 'accounts/projection',
  docusignCreate: apiUrl + 'accounts/docusign',
  currencyRates: apiUrl + 'accounts/conversionrates/',
  cashPosition: apiUrl + 'accounts/cashposition',
  userDocuments: apiUrl + 'accounts/document/templates',
  addressDetails: apiUrl + 'clients/getfooterinfo',
  dfm: apiUrl + 'accounts/dfm',
  dueDiligenceReminder: apiUrl + 'accounts/duediligence/reminder',
  dueDiligenceSkip: apiUrl + 'accounts/duediligence/{bostonId}/skip',
  dueDiligenceDetails: apiUrl + 'accounts/duediligence/details',
  dueDiligenceMetadata: apiUrl + 'accounts/duediligence/metadata',
  dueDiligenceAdminClients:
    apiUrl + 'accounts/dueDiligences/{whitelabelId}/clients',
  getDueDiligenceById: apiUrl + 'accounts/dueDiligence/',
  downloadDueDiligenceDoc:
    apiUrl + 'accounts/dueDiligences/documents/download/',
  getDocumentTypes: apiUrl + 'accounts/dueDiligences/documents/',
  dueDiligenceRequiredDocuments:
    apiUrl + 'accounts/duediligences/{id}/required-documents',
  uploadDueDiligenceDoc: apiUrl + 'accounts/dueDiligences',
  dueDiligenceClients:
    apiUrl +
    'accounts/duediligences/{whitelabelId}/consultants/{consultantId}/clients',
  products: apiUrl + 'products/search',
  productOptions: apiUrl + 'products/options',
  productTotals: apiUrl + 'products/totalproduct',
  notesProviders: apiUrl + 'products/providers',
  fixedIncome: apiUrl + 'products/fixedincome',
  fixedIncomeProviders: apiUrl + 'products/fixedincome/distributors',
  equities: apiUrl + 'products/equities',
  rssFeed: apiUrl + 'products/rssfeed',
  cart: apiUrl + 'products/cart',
  addCart: apiUrl + 'products/addCart',
  updateCart: apiUrl + 'products/updateCart',
  sellCart: apiUrl + 'products/sellCart',
  deleteCart: apiUrl + 'products/deleteCart',
  processCart: apiUrl + 'products/ProcessTrade',
  fundFactSheet: apiUrl + 'products/fundfactsheet',
  fundFactSheetURL: apiUrl + 'products/fundfactsheeturl',
  fundSummary: apiUrl + 'products/fundsummary',
  notesFundFactSheet: apiUrl + 'products/notesfundfactsheet',
  pendingOrders: apiUrl + 'products/pendingorders',
  docusignOrders: apiUrl + 'products/docusignTrade',
  amc: apiUrl + 'products/amc',
  amcProviders: apiUrl + 'products/amc/providers',
  consultantSummary: apiUrl + 'clients/consultant/productbreakdown/',
  consultantClientList: apiUrl + 'clients/consultant/',
  adminClientList: apiUrl + 'clients/adminclientmanagement/',
  networkAdminDirectory: apiUrl + 'clients/networkadmindirectory/',
  investmentSummary: apiUrl + 'clients/investmentsummary/',
  getWatchlist: apiUrl + 'watchlist/getlist',
  addWatchlist: apiUrl + 'watchlist/addwatchlist',
  addClientWatchlist: apiUrl + 'watchlist/addclientwatchlist',
  removeWatchlist: apiUrl + 'watchlist/removeWatchlist',
  editWatchlist: apiUrl + 'watchlist/editWatchlist',
  getAlerts: apiUrl + 'alerts/',
  setAlert: apiUrl + 'alerts/save',
  consultantList: apiUrl + 'clients/getconsultantlist',
  consultantClientAccess: apiUrl + 'authentication/clientaccess',
  CPHQAuth: apiUrl + 'authentication/cphqauthenticate',
  missingDocuments: apiUrl + 'missing-documents',
  docusignDocument: apiUrl + 'missing-documents/docusign/appropriateness',
  userinfo: apiUrl + 'userinfo',
  clients: apiUrl + 'online-document/customers',
  clientFeeSchedule: apiUrl + 'online-document/fees',
  getClientAddress: apiUrl + 'online-document/customers',
  generateDocument: apiUrl + 'online-document',
  createLog: apiUrl + 'alerts/createlog',
  userActivityLog: apiUrl + 'log/useractivitylog',
  getEmailLogs: apiUrl + 'email/get-email-log',
  emailEvents: apiUrl + 'notifications/email-events',
  notificationPopupsActive: apiUrl + 'notifications/popups/active',
  notificationPopupSeen: apiUrl + 'notifications/popups/',
  licenses: apiUrl + 'licenses/',
} as const;

export type Endpoints = keyof typeof endpoints;

export { endpoints };
